<script>
import moment from 'moment';
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';

export default {
	components: { Datatable },
	props : {
	},
  data() {
    return {
			tableData : [],
			moment : moment(),
			testMode : true,

			tableOption : {
				scrollY: 400,
				paging : false,
				searching: false,
				lengthChange: false,
				columns : [
					{data : 'no', width: 100},
					{data : 'title', width: 100},
					{data : 'artist', width: 100},
					{data : 'regdate', width : 80},
					{data : 'result',  width : 150},
				],
				columnDefs : [
					{
						render : (data, type, row) => {
							if(!data) {
								return '';
							}

							return data;
						},
						targets : 4
					},

				]
			},


    }
	},
	created() {
	},
	mounted() {
	},
	methods : {
		show() {
			this.moment = moment();
			this.testMode = true;
			this.tableData = [];

			this.$refs.modal.show();	
		},

		update() {
			const yyyymm = this.moment.format('YYYYMM');
			AxiosHelper.get(`${this.url}${yyyymm}`, {
				params : {
					testMode : this.testMode
				}
			}).then(ret => {
				this.tableData = ret.data;
			});
		},
		
		tjUpdate() {
			this.url = `/api/music/update/tj/`;
			this.moment = moment();
			this.update();
		},

		kyUpdate() {
			this.url = `/api/music/update/ky/`;
			this.moment = moment();
			this.update();
		},

		prevMonth() {
			this.moment = this.moment.add(-1, 'months')	// 1달전
			this.update();
		},

	}
}
</script>

<template>
	<C.Modal ref="modal" title='최근정보 업데이트'
		dialog-class-name="modal-dialog-scrollable modal-lg"
	>
		<C.Row>
			<C.Col lg="6">
				<div class="form-row align-items-center">
					<div class="col-auto">
						<div class="custom-control custom-checkbox mb-2">
							<input id="testMode" v-model="testMode" type="checkbox" class="custom-control-input"/>
							<label class="custom-control-label" for="testMode">테스트모드</label>
						</div>
					</div>
					<div class="col-auto">
						<div class="button-list">
							<button type="button" class="btn btn-primary waves-effect waves-light mb-2" @click="tjUpdate">태진</button>
							<button type="button" class="btn btn-primary waves-effect waves-light mb-2" @click="kyUpdate">금영</button>
						</div>
					</div>
				</div>
			</C.Col>
			<C.Col lg="6">
				<div class="form-row align-items-center justify-content-end">
					<div class="col-auto">
						<label>{{moment.format('YYYY년 MM월')}}</label>
					</div>
					<div class="col-auto">
						<button type="button" class="btn btn-success waves-effect waves-light mb-2" @click="prevMonth">다음</button>
					</div>
				</div>
			</C.Col>
		</C.Row>
		<C.Row>
			<C.Col lg="12">
				<Datatable
					:data="tableData"
					:option="tableOption"
					table-add-classes='table-xs'
					table-remove-classes='table-sm'
				>
					<template v-slot:thead>
						<tr>
							<th>번호</th>
							<th>제목</th>
							<th>가수</th>
							<th>날짜</th>
							<th>처리결과</th>
						</tr>
					</template>
				</Datatable>
			</C.Col>
		</C.Row>
	</C.Modal>
</template>